module.exports = __webpack_public_path__ + "static/openinno-00ac21e8a94634edf5dca3e0f7a4f436.jpg";